import * as React from 'react'

// Lazy on purpose: react-qrcode-logo is a CommonJS lib that synchronously
// requires react-dom at module load. Kept out of the eager bootstrap chunk it
// crashes under Module Federation's async-shared react-dom ($Se is not
// defined). Do not convert this back to a static `react-qrcode-logo` import.
const LazyQRCode = React.lazy(async () => ({
  default: (await import('react-qrcode-logo')).QRCode,
}))

type QRCodeProps = React.ComponentProps<typeof LazyQRCode>

export const QRCode: React.FC<QRCodeProps> = props => (
  <React.Suspense fallback={null}>
    <LazyQRCode {...props} />
  </React.Suspense>
)
